import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCopyTrading = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M5.837 6.515a8.25 8.25 0 0 1 14.382 4.767.75.75 0 1 0 1.494-.13c-.468-5.365-5.197-9.334-10.561-8.865a9.72 9.72 0 0 0-6.488 3.291l-.106-1.21a.75.75 0 0 0-1.494.13l.26 2.99a.75.75 0 0 0 .813.681l2.989-.26a.75.75 0 0 0-.13-1.495l-1.16.101Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M10.5 8.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm0 6a3.375 3.375 0 1 1 6.75 0V15a.75.75 0 0 1-.75.75h-5.25a.75.75 0 0 1-.75-.75v-.375Zm5.212-.375a1.876 1.876 0 0 0-3.675 0h3.675Zm-1.837-3.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm-4.125 0A3.75 3.75 0 0 0 6 14.25c0 .414.336.75.75.75H9a.75.75 0 0 0 0-1.5H7.628A2.25 2.25 0 0 1 9.75 12a.75.75 0 0 0 0-1.5Zm-6.781 1.536a.75.75 0 0 1 .812.681 8.25 8.25 0 0 0 14.382 4.768l-1.159.1a.75.75 0 1 1-.13-1.494l2.988-.26a.75.75 0 0 1 .813.681l.26 2.99a.75.75 0 0 1-1.493.13l-.106-1.21a9.719 9.719 0 0 1-6.488 3.291c-5.365.468-10.093-3.5-10.561-8.865a.75.75 0 0 1 .682-.812Z"
    />
  </svg>
);
export default SvgTwoColorCopyTrading;
